import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface TickerSymbolProps {
  ticker: string;
  asLink?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Canonical ticker symbol primitive.
 * Apple/ThinkOrSwim hybrid: cyan, monospace, tabular-nums, tight tracking.
 * Renders as a Link to /stock/[ticker] by default.
 * Stops click propagation so it never triggers parent row expand.
 */
const TickerSymbol = ({
  ticker,
  asLink = true,
  size = 'md',
  className,
}: TickerSymbolProps) => {
  const sizeCls = size === 'sm' ? 'text-xs' : 'text-sm';
  const base = cn(
    'font-mono font-semibold tabular-nums tracking-[0.04em] text-primary',
    sizeCls,
    className,
  );

  if (!asLink) {
    return <span className={base}>{ticker}</span>;
  }

  return (
    <Link
      to={`/stock/${encodeURIComponent(ticker)}`}
      onClick={(e) => e.stopPropagation()}
      className={cn(
        base,
        'transition-colors hover:text-primary/80 hover:underline hover:underline-offset-4',
      )}
    >
      {ticker}
    </Link>
  );
};

export default TickerSymbol;
